import { SHI_SHEET_URL } from "@/lib/images";

export default function ShiSheetCta() {
  return (
    <section id="shi-sheet" data-testid="shi-sheet-section" className="border-y border-[#3B2314]/35 bg-neon py-20 md:py-24">
      <div className="mx-auto flex max-w-7xl flex-col gap-8 px-5 md:px-10 lg:flex-row lg:items-end lg:justify-between">
        <div className="max-w-3xl">
          <p className="font-sans text-[11px] font-bold uppercase tracking-[0.3em] text-ink">The Newsletter</p>
          <h2 className="mt-3 font-editorial text-5xl italic leading-none text-ink md:text-7xl">The Shi Sheet</h2>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-ink/85 md:text-lg">
            Premiere news, early Shi Sips recipes, new music, and the occasional opinion. Only when there&rsquo;s something to send.
          </p>
        </div>
        <a
          href={SHI_SHEET_URL}
          target="_blank"
          rel="noopener"
          data-testid="shi-sheet-cta-button"
          className="inline-flex shrink-0 items-center justify-center rounded-full border-2 border-gold bg-ink px-8 py-4 font-sans text-sm font-bold uppercase tracking-[0.16em] text-neon transition-colors hover:bg-cocoa"
        >
          Get The Shi Sheet
        </a>
      </div>
    </section>
  );
}